module.exports = __webpack_public_path__ + "static/media/google-logo.554640f4.svg";